import React from 'react';

export const ContextMenuContext = React.createContext({
  isShowcontextMenu: false,
  onIsShowcontextMenu: null,
  positionContextMenu: null,
  onPositionContextMenu: null
});